import axiosInstance from 'services/axiosInstance';
import {
  IExternalLoginPayload,
  IGoogleSettings,
  ILoginRequestPayload,
  ILoginResponse,
  IMicrosoftSettings,
} from 'services/authorization/types';
import { IResponse } from 'services/types';

export const login = (payload: ILoginRequestPayload): IResponse<ILoginResponse> =>
  axiosInstance.request({
    url: '/Token',
    method: 'POST',
    data: payload,
  });

export const mfaLogin = (payload: ILoginRequestPayload): IResponse<ILoginResponse> =>
  axiosInstance.request({
    url: '/User/MultiFactorLogin',
    method: 'POST',
    data: payload,
  });

export const externalLogin = (payload: IExternalLoginPayload): IResponse<ILoginResponse> =>
  axiosInstance.request({
    method: 'POST',
    url: '/User/ExternalLogin',
    data: payload,
  });

export const getMicrosoftSettings = (): IResponse<IMicrosoftSettings> =>
  axiosInstance.request({ method: 'GET', url: 'Account/get-msal-settings' });

export const getGoogleSettings = (): IResponse<IGoogleSettings> =>
  axiosInstance.request({
    method: 'GET',
    url: 'Account/get-google-api-settings',
  });

export const loginPreCheck = (
  payload: ILoginRequestPayload,
): IResponse<{ url?: string; mfaRequired?: boolean }> =>
  axiosInstance.request({
    method: 'POST',
    url: 'User/preCheck',
    data: payload,
    params: { source: 1 },
  });
